export default __webpack_public_path__ + "static/discover-yield-gradient-7667ac874d447f3db5e1ae0c8f6e5549.svg";